import {
  MARGIN,
  TEXT_PADDING,
} from '@/domain/dienstplan/features/VisualEditor/constants';
import { formatHourDecimalToTimeString } from '@/domain/dienstplan/features/VisualEditor/utils/timeHelper/formatHourDecimalToTimeString';
import { useVisualEditorContext } from '@/domain/dienstplan/features/VisualEditor/VisualEditorContext';
import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';
import { truncateTextIfTooWide } from '@/utils/truncateTextIfTooWide';
import { Bar } from '@visx/shape';
import { BarProps } from '@visx/shape/lib/shapes/Bar';
import { AddSVGProps } from '@visx/shape/lib/types';
import { Text } from '@visx/text';

export function BelegungBar({
  belegung,
  offset,
  ...others
}: { belegung: BelegungsIntervall; offset: number } & AddSVGProps<
  BarProps,
  SVGRectElement
>) {
  const { xScalePoint, yScalePoint, height } = useVisualEditorContext();

  const x = xScalePoint(belegung.startX);
  const y = yScalePoint(belegung.startY);
  const barWidth =
    belegung.endeX !== 0
      ? xScalePoint(belegung.endeX) - xScalePoint(belegung.startX)
      : xScalePoint(24) - xScalePoint(belegung.startX);
  const barHeight = height - MARGIN.bottom - yScalePoint(belegung.height);

  const displayText = truncateTextIfTooWide(
    `${formatHourDecimalToTimeString(
      belegung.belegung.start,
      offset,
    )} - ${formatHourDecimalToTimeString(belegung.belegung.ende, offset)}`,
    barWidth - 2 * TEXT_PADDING,
  );

  return (
    <>
      <Bar
        {...others}
        x={x}
        y={y}
        width={barWidth}
        height={barHeight}
        fill={belegung.fillColor}
        stroke={belegung.borderColor}
        fillOpacity={belegung.mode === 'create' ? 0.5 : 1}
        strokeOpacity={belegung.mode === 'create' ? 0.5 : 1}
        strokeWidth={2}
        rx={6}
        ry={6}
      />
      <Text
        x={x + TEXT_PADDING}
        y={y - 2 * TEXT_PADDING + barHeight}
        textAnchor="start"
        verticalAnchor="start"
        fontSize={12}>
        {displayText}
      </Text>
    </>
  );
}
